import PropTypes from 'prop-types';
import React from 'react';
import { noop } from 'lodash';
import { encode as encodeBase64 } from 'base-64';

import { ConfigsService, LocaleService, WindowProxy, UrlService } from '@sm360/widget-commons-core-services';
import { AccountService, REDIRECTIONS } from '@sm360/widget-commons-general';

import QuoteModel from 'commons-vehicle/Quote/models/QuoteModel.js';
import QuoteService from 'commons-vehicle/Quote/services/QuoteService/QuoteService.js';
import ShowroomService from 'commons-vehicle/services/ShowroomService/ShowroomService.js';

import 'commons-vehicle/Vehicle/components/CallToAction/Appointment/AppointmentCTA.scss';

class AppointmentCTA extends React.Component {
    constructor(props) {
        super(props);
        this.onAppointmentClick = this.onAppointmentClick.bind(this);
    }

    componentDidMount() {
        const locale = LocaleService.getSimpleLocale();
        this.redirect = REDIRECTIONS[locale].appointment;
    }

    onAppointmentClick() {
        const { quote, onClick, onEndProcessGaTag } = this.props;

        onClick();

        const locale = LocaleService.getSimpleLocale();
        const url = REDIRECTIONS[locale].appointment;

        return ShowroomService.saveQuote(quote.getShowroomQuote()).then((showroomQuote) => {
            const newQuote = QuoteService.resetQuoteFromShowroomSave(quote, showroomQuote);
            const windowProxy = WindowProxy.get();

            if (windowProxy) {
                const historyUrl = newQuote.buildUrl(windowProxy.location.href);

                windowProxy.history.replaceState({ quote: newQuote }, 'tradeIn', historyUrl);

                let fullUrl = newQuote.buildUrl(url);
                if (onEndProcessGaTag) {
                    fullUrl += `&${UrlService.encodeUriParameter(
                        'onEndProcessGaTag',
                        encodeBase64(JSON.stringify(onEndProcessGaTag))
                    )}`;
                }

                if (ConfigsService.isInMobileApp() && !AccountService.isAuthenticated()) {
                    windowProxy.location.href =
                        `ca.solutionsmedias360.showroom-${ConfigsService.getWebsiteId()}://` +
                        `?action=login&redirectUrl=${encodeURIComponent(fullUrl)}`;
                } else {
                    windowProxy.location.href = fullUrl;
                }
            }
        });
    }

    render() {
        const { iconClass, buttonClass, alternativeLabel } = this.props;
        const currentClass = [buttonClass, 'vehicle-cta-btn'];
        return (
            <button className={currentClass.join(' ')} onClick={this.onAppointmentClick}>
                {iconClass && <icon className={iconClass} />}
                <span>{alternativeLabel || LocaleService.t('CALL_TO_ACTION.BTN_BOOK_APPOINTMENT_TITLE')}</span>
            </button>
        );
    }
}

AppointmentCTA.defaultProps = {
    alternativeLabel: '',
    buttonClass: 'sr-button-2',
    iconClass: null,
    onClick: noop,
    onEndProcessGaTag: null,
};

AppointmentCTA.propTypes = {
    alternativeLabel: PropTypes.string,
    buttonClass: PropTypes.string,
    quote: PropTypes.instanceOf(QuoteModel).isRequired,
    iconClass: PropTypes.string,
    onClick: PropTypes.func,
    onEndProcessGaTag: PropTypes.shape({
        category: PropTypes.string.isRequired,
        action: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }),
};

AppointmentCTA.displayName = 'AppointmentCTA';

export default AppointmentCTA;
